import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Container,
  Grid,
  Paper,
  Button,
  Tooltip,
  TextField,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
//import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import GetAppIcon from '@material-ui/icons/GetApp';
import CheckIcon from '@material-ui/icons/Check';
//import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import { makeAPICall } from '../../core/services/http-request';
import { downloadFile } from '../../core/downloadService';
import {
  BlockComponent,
  Header,
  GridItem,
  DynamicTable,
} from '@intervan-ar/ov-componentes';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useLocation } from "react-router-dom";

const Recibos = props => {
  const { headerProps } = props;
  const [recibos, setRecibos] = useState();
  const [loading, setLoading] = useState(false);
  const user = useSelector(state => {
    return state.auth.user;
  });

  const logoURL = useSelector(state => {
    return state.parametros.data?.OV_APP_LOGO_URL?.valor;
  });

  const parametros = useSelector(state => {
    return state.parametros.data;
  });

  const location = useLocation();
  const rutaActual = location.pathname.split("/");

  const [tiposConformidad, setTitposConformidad] = useState([
    {
      codigo: 'CON',
      descripcion: 'Conformidad',
      observaciones: 'N',
      color: '#00FF00',
    },
    {
      codigo: 'CCN',
      descripcion: 'Conformidad con Obs.',
      observaciones: 'S',
      color: '#ffeb3b',
    },
    {
      codigo: 'DIS',
      descripcion: 'Disconformidad',
      observaciones: 'S',
      color: '#ff0000',
    },
  ]);

  const celDisplay = useMediaQuery('(min-width:600px)');
  const [openConformidad, setOpenConformidad] = useState(false);
  const [openMessageVig, setOpenMessageVig] = useState(false);

  const [valuesConformidad, setValuesConformidad] = useState({
    id_recibo: '',
    conformidad: 'CON',
    observaciones: '',
  });
  //const [diasVigencia, setdiasVigencia] = useState(30);

  const diasVigencia = useSelector(state => {
    return state.parametros.data?.VIGENCIA_ACTUALIZAR_CONFORMIDAD?.valor || 30;
  });

  //const tableRecibos = useSelector(state => {
  //  if (state.parametros.data?.OV_RRHH_GRILLA_RECIBOS?.valor !== undefined)
  //    return JSON.parse(state.parametros.data?.OV_RRHH_GRILLA_RECIBOS?.valor);
  //  else return null;
  //});

  const tableRecibos = JSON.parse(`{"columns":[{"header":"Liquidacion","accessor":"id_liquidacion","style":{"textAlign":"left"},"minWidth":10,"cellContent":"row.original.id_liquidacion","cellStyle":{"fontWeight":"row.original.conformidad === '' || row.original.conformidad === null ? 'normal' : '900'"},"sortMethod":"(a, b) => {return Number(a) > Number(b) ? 1 : -1;}"},{"header":"Periodo","accessor":"periodo","headerStyle":{"textAlign":"left"},"minWidth":12,"cellStyle":{"fontWeight":"row.original.conformidad === '' || row.original.conformidad === null ? 'normal' : '900'"}},{"header":"Fecha Pago","accessor":"fecha_pago","style":{"textAlign":"left"},"minWidth":15,"cellContent":"new Date(row.value).getDate() + '/' + (new Date(row.value).getMonth() + 1) + '/' + new Date(row.value).getFullYear()","cellStyle":{"fontWeight":"row.original.conformidad === '' || row.original.conformidad === null ? 'normal' : '900'"}},{"header":"Tipo Liquidacion","accessor":"tipo_liquidacion","headerStyle":{"textAlign":"left"},"style":{"textAlign":"left"},"minWidth":20,"cellContent":"row.original.tipo_liquidacion","cellStyle":{"fontWeight":"row.original.conformidad === '' || row.original.conformidad === null ? 'normal' : '900'"},"sortMethod":"(a, b) => { return String(a) > String(b) ? 1 : -1;}"}],"acordeon":{"totalColumnas":3,"campos":[{"accessor":"fecha_descarga","ancho":1,"tipo":"fecha","descripcion":"Fecha 1er Descarga"},{"accessor":"mail_descarga","ancho":1,"tipo":"","descripcion":"Email Descarga"},{"accessor":"conformidad_desc","ancho":1,"tipo":"","descripcion":"Conformidad"},{"accessor":"observaciones","ancho":1,"tipo":"","descripcion":"Observaciones"},{"accessor":"fecha_conformidad","ancho":1,"tipo":"fecha","descripcion":"Fecha Conformidad"}]},"filterable":true,"resizable":true,"defaultPageSize":7,"showPageSizeOptions":true,"showPaginationTop":false,"showPaginationBottom":true,"defaultSorted":[{"id":"id_liquidacion","desc":true}],"className":"mainTable","previousText":"<","nextText":">","loadingText":"Cargando...","pageText":"Página","ofText":"de","rowsText":"filas","filtros":[{"campo":"tipo_liquidacion","tag":"tipo_liquidacion","active":true,"orden":1},{"campo":"anio","tag":"anio","active":true,"orden":2}],"subComponent":"props.subData(row)"}`);

  const get = async () => {
    setLoading(true);
    const req = {
      requestConfig: {
        method: 'get',
        params: {
          usuario: user.id,
        },
        url: '/rrhh/recibos_sueldo',
      },
      methodCall: '',
      needsToken: true,
    };
    const response = await makeAPICall(req);
    if (response.data && response.data.length > 0) {
      setRecibos(response.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (user) get();
  }, [user]);

  useEffect(() => {
    if (parametros?.OV_RRHH_TIPOS_CONFORMIDAD?.valor)
      setTitposConformidad(parametros.OV_RRHH_TIPOS_CONFORMIDAD.valor);
  }, [parametros]);

  const onDownloadClick = idComprobante => {
    setLoading(true);
    const req = {
      requestConfig: {
        method: 'get',
        params: {
          id_recibo: idComprobante,
        },
        url: '/rrhh/imprimir_recibo',
      },
      methodCall: '',
      needsToken: true,
    };
    makeAPICall(req).then(res => {
      downloadFile(res.data, 'recibo_' + idComprobante + '.pdf');
      setLoading(false);
      get();
    });
  };

  const changeConformidad = id => {
    setValuesConformidad({ ...valuesConformidad, id_recibo: id });
    setOpenConformidad(true);
  };

  const confirmConformidad = () => {
    setLoading(true);
    setOpenConformidad(false);
    const req = {
      requestConfig: {
        method: 'post',
        data: valuesConformidad,
        url: '/rrhh/confirmar_recibo',
      },
      methodCall: '',
      needsToken: true,
    };
    makeAPICall(req)
      .then(res => {
        setLoading(false);
        get();
      })
      .catch(e => {
        console.log('error', e);
      });
  };

  const hanldeChangeValues = e => {
    setValuesConformidad({
      ...valuesConformidad,
      [e.target.name]: e.target.value,
    });
  };

  const tableActions = items => {
    return items.map(item => {
      let fecha_pago = item.fecha_pago.substr(0, 10);
      fecha_pago = new Date(fecha_pago);
      fecha_pago = fecha_pago.setDate(fecha_pago.getDate() + diasVigencia);
      const hoy = new Date().getTime();

      let btnConfDisabled = fecha_pago <= hoy ? true : false;

      return {
        ...item,
        /*icons: (
          <div className={classes.rowIcons}>
            <GetAppIcon
              fontSize="small"
              style={{
                color:
                  item.fecha_descarga === '' || item.fecha_descarga === null
                    ? 'grey'
                    : 'green',
              }}
            />
            <CheckIcon
              fontSize="small"
              style={{
                color:
                  item.conformidad === 'CON'
                    ? 'green'
                    : item.conformidad === 'COO'
                    ? 'yellow'
                    : item.conformidad === 'DIS'
                    ? 'red'
                    : 'grey',
              }}
            />
          </div>
        ),*/
        actions: (
          <div className="actions-right">
            <Button
              onClick={() => onDownloadClick(item.id_comprobante)}
              className={classes.botonDescarga}
              //color="primary"
            >
              <Tooltip
                id="tooltip-download"
                title={
                  parametros?.OV_RRHH_DESCARGAR_TP?.valor
                    ? parametros.OV_RRHH_DESCARGAR_TP.valor
                    : 'Descargar Recibo'
                }
                placement="top"
              >
                <GetAppIcon
                  /*style={{
                    color: tiposConformidad.find(
                      t => t.codigo === item.conformidad
                    )
                      ? tiposConformidad.find(
                          t => t.codigo === item.conformidad
                        ).color
                      : 'grey',
                  }}*/
                  style={{
                    color:
                      item.fecha_descarga === '' || item.fecha_descarga === null
                        ? 'grey'
                        : 'green',
                  }}
                />
              </Tooltip>
            </Button>
            <Button
              onClick={() =>
                btnConfDisabled
                  ? setOpenMessageVig(true)
                  : changeConformidad(item.id_comprobante)
              }
              className={classes.botonConformidad}
              //color="primary"
              //disabled={btnConfDisabled}
            >
              <Tooltip
                id="tooltip-conformidad"
                title={
                  parametros?.OV_RRHH_CONFORMIDAD_TP?.valor
                    ? parametros.OV_RRHH_CONFORMIDAD_TP.valor
                    : 'Conformidad'
                }
                placement="top"
              >
                <CheckIcon
                  style={{
                    stroke: tiposConformidad.find(
                      t => t.codigo === item.conformidad
                    )
                      ? tiposConformidad.find(
                          t => t.codigo === item.conformidad
                        ).color
                      : 'grey',
                    strokeWidth: '4',
                  }}
                />
              </Tooltip>
            </Button>
          </div>
        ),
      };
    });
  };

  if (tableRecibos) tableRecibos.actions = tableActions;

  const useStyles = makeStyles(theme => ({
    paperRecibos: {
      marginTop: '80px',
    },
    tableRecibos: {
      fontSize: celDisplay ? '12px' : '10px',
    },
    botonDescarga: {
      justifyContent: 'left',
      minWidth: 'fit-content',
      paddingLeft: '0px',
      paddingRight: '0px',
      '& svg': {
        fontSize: celDisplay ? '20px' : '15px',
      },
    },
    botonConformidad: {
      justifyContent: 'left',
      minWidth: 'fit-content',
      '& svg': {
        fontSize: celDisplay ? '20px' : '15px',
      },
    },
    rowIcons: {
      '& svg': {
        fontSize: celDisplay ? '20px' : '15px',
      },
    },
    mainSub: {
      padding: '20px',
    },
    subItem: {
      '& input': { fontSize: celDisplay ? '12px' : '10px' },
      '& textarea': { fontSize: celDisplay ? '12px' : '10px' },
      '& label': { fontSize: celDisplay ? '15px' : '12px' },
    },
    modalConformidad: {
      position: 'absolute',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: 'none',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      left: '20%',
      top: '20%',
      borderRadius: '10px',
    },
    modalActions: {
      paddingTop: '20px',
      display: 'flex',
      justifyContent: 'space-evenly',
    },
    sinConformidad: {
      fontWeight: '900',
    },
  }));
  const classes = useStyles();

  //console.log(recibos);
  return (
    <Container>
      <Header {...headerProps} logoURL={logoURL} showTitle={true}></Header>
      <BlockComponent blocking={loading}>
        <Paper className={classes.paperRecibos}>
          {tableRecibos && recibos && (
            <DynamicTable
              table={tableRecibos}
              data={recibos}
              classTable={classes.tableRecibos}
              nombreConsulta={rutaActual[rutaActual.length -1]}
            />
          )}
        </Paper>
        <Modal
          open={openMessageVig}
          onClose={() => setOpenMessageVig(false)}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div className={classes.modalConformidad}>
            <h3>
              {parametros?.OV_RRHH_MENSAGE_VIGENCIA?.value ||
                `Solo tiene ${diasVigencia} días para modificar la conformidad del recibo de
              sueldo`}
            </h3>
            <div className={classes.modalActions}>
              <Button
                onClick={() => setOpenMessageVig(false)}
                color="primary"
                variant="contained"
              >
                Cerrar
              </Button>
            </div>
          </div>
        </Modal>

        <Modal
          open={openConformidad}
          onClose={() => setOpenConformidad(false)}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div className={classes.modalConformidad}>
            <FormControl className={classes.formControl} fullWidth={true}>
              <InputLabel htmlFor="tipoDocumento">Tipo Conformidad</InputLabel>
              <Select
                name="conformidad"
                inputProps={{
                  name: 'conformidad',
                }}
                className={classes.selectEmpty}
                MenuProps={{
                  className: classes.selectMenu,
                }}
                value={valuesConformidad.conformidad}
                onChange={hanldeChangeValues}
              >
                {tiposConformidad.map(t => (
                  <MenuItem key={t.codigo} value={t.codigo}>
                    {t.descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {tiposConformidad.find(
              t => t.codigo === valuesConformidad.conformidad
            ).observaciones === 'S' && (
              <TextField
                id="observaciones2"
                label="Observaciones"
                name="observaciones"
                margin="normal"
                size="small"
                className={classes.subItem}
                fullWidth
                multiline
                rows={4}
                value={valuesConformidad.observaciones}
                onChange={hanldeChangeValues}
              />
            )}
            <div className={classes.modalActions}>
              <Button
                onClick={confirmConformidad}
                color="primary"
                variant="contained"
              >
                Ok
              </Button>
              <Button
                onClick={() => setOpenConformidad(false)}
                color="primary"
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      </BlockComponent>
    </Container>
  );
};

export default Recibos;
